import { FC } from 'react';

interface IAnalyticsStackedTimeSeriesSegmentSwatchProps {
  color?: string;
}

export const AnalyticsStackedTimeSeriesSegmentSwatch: FC<IAnalyticsStackedTimeSeriesSegmentSwatchProps> = ({
  color
}) => (
  <div
    className="w-2 h-2 rounded-sm shrink-0"
    style={{ backgroundColor: color }}
  />
);
